import { produce } from 'immer';
import { orderBy } from 'lodash';

import { SortInternalProducts } from '../../../actions/products/internal/sortInternalProducts';
import { routeToKeyMap } from '../../../service/ProductsHelpers';
import { Product, ProductsState } from '../../../typings/products';

export function sortInternalProducts(state: ProductsState, action: SortInternalProducts): ProductsState {
    return produce(state, draft => {
        const iteratees = [routeToKeyMap[action.sortParams.key]];
        const orders = [action.sortParams.direction];

        draft.products = orderBy<Product>(draft.products, iteratees, orders);
        draft.filtered = orderBy<Product>(draft.filtered, iteratees, orders);
    });
}
